import styles from "./DashboardNav.module.scss";

type DashboardNavProps = {
  image: string;
  text: string;
  element: JSX.Element;
};

export const DashboardNav = ({ image, text, element }: DashboardNavProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.image}>
        <img src={image} alt='img' />
      </div>
      <p className={styles.text}>{text}</p>
      {element}
    </div>
  );
};
